import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

let apiToken = JSON.parse(localStorage.getItem("authUser"))
const headers = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
  Authorization: apiToken,
  Accept: "application/json",
  "Cache-Control": "no-cache",
}

//to create access profiles

export const createAccessProfileAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    console.log(payload)
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    return await axios.post(`${apiBaseUrl}/create-user-role`, payload, {
      headers,
      payload,
    })
   // return response
  } catch (error) {
    console.error("Error Creating Profile for Access:", error)
    throw error
  }
}

//  to get Access profiles

export const getAccessProfileAPI = async()  => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-user-role`, {
    headers,
  })
}



//  to get Routes

export const getRoutesAPI = async() => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-all-routes`, {
    headers,
  })
}



//to Assign profiles to employees

export const assignRoutesAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    console.log(payload)
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    return await axios.post(`${apiBaseUrl}/assign-roles`, payload, {
      headers,
      payload,
    })
   // return response
  } catch (error) {
    console.error("Error Assigning Profile to Employee:", error)
    throw error
  }
}


//  to get assigen Routes 

export const getEmpRoutesAPI = async(roleID) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
console.log(roleID)
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-my-routes?roleID=${roleID}`, {
    headers,
  })
}

// to  get all employees

export const getAccessEmployeeAPI = async () => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-all-employees`, {
    headers,
  })
}



// to  get all employees

export const updateAccessProfileAPI = async (payload) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/update-role-premissions`, payload, {
    headers
  })
}


export const getAccessOtherRoutesAPI = async () => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-other-routes`, {
    headers
  })
}


export const updateAccessOtherRoutesAPI = async (payload) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/update-other-premissions`, payload, {
    headers
  })
}


export const getMyAccessOtherRoutesAPI = async (roleID) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-my-other-routes?roleID=${roleID}`, {
    headers
  })
}
